<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import type { Survey } from '../interfaces/survey-search.interface'
    import { inflect } from '../../../core/helpers/string.helper'
    import Config from "../../../core/config/index";

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    let surveyList: Survey[] = []
    let total = 0
    let error = false
    let processing = false
    let activeIndex = 0
    let listLength = 0

    serviceProvider.surveySearchService.listSubs.subscribe((list) => {
        surveyList = list
        listLength = list.length
    })
    serviceProvider.surveySearchService.totalSubs.subscribe((number) => (total = number))
    serviceProvider.surveySearchService.errorSubs.subscribe((status) => (error = status))
    serviceProvider.surveySearchService.processingSubs.subscribe((status) => (processing = status))

    const imgW = '348' // maximum img width on some viewport size

    function prev() {
        activeIndex = (activeIndex === 0) ? listLength - 1 : activeIndex - 1
    }

    function next() {
        activeIndex = (activeIndex === listLength - 1) ? 0 : activeIndex + 1
    }

    const fragmentImgPlaceholder = `
        <span class="dnv-survey-preview-tile__placeholder">
            <img src="${Config.themeBaseUrl}/assets/images/dnv-placeholders/ankety.png" width="316" height="200" alt="">
        </span>
    `
</script>

<h2>{dataProvider.heading}</h2>

{#if processing}
    <div class="dnv-survey-preview-tile">
        <div class="dnv-survey-preview-tile__header">
            {@html fragmentImgPlaceholder}
        </div>
    </div>
{:else if error}
    <div class="dnv-survey-preview-tile">
        <div class="dnv-survey-preview-tile__header">
            {@html fragmentImgPlaceholder}
        </div>
        <div class="dnv-survey-preview-tile__content">
            <p>Nastala chyba při načítání anket.</p>
        </div>
    </div>
{:else if !Array.isArray(surveyList) || !listLength}
    <div class="dnv-survey-preview-tile">
        <div class="dnv-survey-preview-tile__header">
            {@html fragmentImgPlaceholder}
        </div>
    </div>
{:else}
    <div class="dnv-carousel-wrap">
        <div class="dnv-carousel-wrap__container">
            <div class="dnv-carousel-wrap__slider">
                {#each surveyList as item, index}
                    <div class="bno-grid__tile--top {(index == activeIndex) ? 'active' : ''}" data-index="{index}">
                        <div class="bno-grid__tile">
                            <a href="{item.url}" class="dnv-survey-preview-tile" aria-label="{item.title}">
                                <div class="dnv-survey-preview-tile__header">
                                    {#if item.image}
                                        <img
                                            src="{dataProvider.portalUrl}/picfit/display?url={dataProvider.portalUrl}{item.image}&w={imgW}&op=resize"
                                            alt={item.title}
                                        />
                                    {:else}
                                        {@html fragmentImgPlaceholder}
                                    {/if}
                                    <div class="dnv-survey-preview-tile__date">
                                        <span class="bno-chip bno-chip--primary bno-chip--large">
                                            <span class="bno-chip__inner">Zbývá <strong>{item.timeToUnpublish}</strong></span>
                                        </span>
                                    </div>
                                </div>
                                <div class="dnv-survey-preview-tile__content">
                                    <h4>{item.title}</h4>
                                    <div class="dnv-survey-preview-tile__votes">
                                        <span class="dnv-survey-preview-tile__votes-icon">
                                            <span class="bno-complex-icon bno-complex-icon--obna bno-complex-icon--dnv" aria-hidden="true"></span>
                                        </span>
                                        <p><strong>{item.numOfEntries}</strong> {inflect('respondentu', item.numOfEntries)}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                {/each}
            </div>
            {#if surveyList?.length > 1}
                <button
                    class="dnv-carousel-wrap__controls dnv-carousel-wrap__controls--left"
                    aria-label="Přejít na předchozí slide"
                    on:click={prev}
                >
                    <span class="bno-icon bno-icon--arrow-narrow bno-icon--16x16" aria-hidden="true"></span>
                </button>
                <ul class="bno-list--plain dnv-carousel-wrap__points">
                    {#each surveyList as item, index}
                        <li>
                            <button
                                data-index="{index}"
                                class="{index == activeIndex ? 'active' : ''}"
                                aria-current="{index == activeIndex ? 'step' : null}"
                                aria-label="Přejít na slide {index}"
                                on:click={() => {activeIndex = index}}
                            >
                                &nbsp;
                            </button>
                        </li>
                    {/each}
                </ul>
                <button
                    class="dnv-carousel-wrap__controls dnv-carousel-wrap__controls--right"
                    aria-label="Přejít na následující slide"
                    on:click={next}
                >
                    <span class="bno-icon bno-icon--arrow-narrow bno-icon--16x16" aria-hidden="true"></span>
                </button>
            {/if}
        </div>
    </div>
{/if}

<style>
    .bno-grid__tile--top:not(.active) {
        display: none;
    }
</style>